import React from "react"
import {Trans} from "@lingui/react/macro"
import styles from "./styles.module.css"
import ArticleCard from "./ArticleCard"

export default function Recommendations({context, items}) {
    if (!Array.isArray(items) || items.length === 0) return null

    return (
        <section className={styles.recommendations}>
            <div className={styles.sectionHeader}>
                <h2 className={styles.sectionTitle}><Trans>Articles recommandés</Trans></h2>
            </div>
            <div className={styles.articlesGrid}>
                {items.map(it => (
                    <ArticleCard key={it.aid} context={context} article={it}/>
                ))}
            </div>
        </section>
    )
}
